import { Direction } from '../../hooks';
import { IPriceRequestResponse } from '../../hooks/useTradeEstimate';

interface ISwapState {
  baseBalance: number;
  quoteBalance: number;
  baseUSDBalance: string;
  quoteUSDBalance: string;
  gasCostUSD: string;
  minReceived: string;
  direction: Direction;
  priceRoute: IPriceRequestResponse | undefined;
  estimated: boolean;
  estimateIndex: number;
  lastUpdated: number;
  estimationBase: boolean;
  estimationQuote: boolean;
}

export enum SwapActions {
  SetBaseBalance = 'SWAP_SET_BASE',
  SetQuoteBalance = 'SWAP_SET_QUOTE',
  SetBaseUSDBalance = 'SWAP_SET_BASE_USD',
  SetQuoteUSDBalance = 'SWAP_SET_QUOTE_USD',
  SetGasCostUSD = 'SWAP_SET_GAS_USE',
  SetMinReceived = 'SWAP_SET_MIN',
  SetDirection = 'SWAP_SET_DIRECTION',
  SetPriceRoute = 'SWAP_SET_PRICE_ROUTE',
  SetEstimated = 'SWAP_SET_ESTIMATED',
  SetEstimateIndex = 'SWAP_SET_ESTIMATED_INDEX',
  SetLastUpdated = 'SWAP_SET_LAST_UPDATED',
  ToggleEstimationBase = 'SWAP_TOGGLE_ESTIMATION_BASE',
  ToggleEstimationQuote = 'SWAP_TOGGLE_ESTIMATION_QUOTE',
}

export const initialSwapState: ISwapState = {
  baseBalance: 0,
  quoteBalance: 0,
  baseUSDBalance: '0.0',
  quoteUSDBalance: '0.0',
  gasCostUSD: '0.0',
  minReceived: '0.0',
  direction: Direction.BaseQuote,
  priceRoute: undefined,
  estimated: false,
  estimateIndex: 0,
  estimationBase: false,
  estimationQuote: false,
  lastUpdated: 0,
};

export const swapReducer = (
  state: ISwapState,
  action: { payload?: any; type: SwapActions }
): ISwapState => {
  switch (action.type) {
  case SwapActions.SetBaseBalance:
    return {
      ...state,
      baseBalance: action.payload,
    };
  case SwapActions.SetQuoteBalance:
    return {
      ...state,
      quoteBalance: action.payload,
    };
  case SwapActions.SetBaseUSDBalance:
    return {
      ...state,
      baseUSDBalance: action.payload,
    };
  case SwapActions.SetQuoteUSDBalance:
    return {
      ...state,
      quoteUSDBalance: action.payload,
    };
  case SwapActions.SetGasCostUSD:
    return {
      ...state,
      gasCostUSD: action.payload,
    };
  case SwapActions.SetMinReceived:
    return {
      ...state,
      minReceived: action.payload,
    };
  case SwapActions.SetDirection:
    return {
      ...state,
      direction: action.payload,
    };
  case SwapActions.SetPriceRoute:
    return {
      ...state,
      priceRoute: action.payload,
    };
  case SwapActions.SetEstimated:
    return {
      ...state,
      estimated: action.payload,
      estimationBase: false,
      estimationQuote: false,
    };
  case SwapActions.SetEstimateIndex:
    return {
      ...state,
      estimateIndex: action.payload,
    };
  case SwapActions.SetLastUpdated:
    return {
      ...state,
      lastUpdated: action.payload,
    };
  case SwapActions.ToggleEstimationBase:
    return {
      ...state,
      estimationBase: true,
    };
  case SwapActions.ToggleEstimationQuote:
    return {
      ...state,
      estimationQuote: true,
    };
  default:
    return state;
  }
};
